<template>
  <VueFragment>
    <SectionRowContainer>
      <b-col>
        <h2><b>COOKIE AND PRIVACY POLICY</b></h2>
        <p>
          WE DO NOT STORE ANY DATA.
        </p>
        <ul>
          <li>No Cookies</li>
          <li>No HTML5 localstorage</li>
          <li>No database servers</li>
          <li>No 3rd party website analytics</li>
          <li>No advertisements</li>
          <li>No asking of any personal info/data</li>
        </ul>
        <p>
          This website is a porfolio about me. I have no reason to store and log
          data about visitors to my site.
        </p>
        <p>
          If you have any questions, feel free to
          <b-link href="mailto:james.choi@mail.utoronto.ca">email me</b-link>.
        </p>
      </b-col>
    </SectionRowContainer>

    <SiteBuiltWithInformation />
  </VueFragment>
</template>

<script>
import { Fragment as VueFragment } from 'vue-fragment';

import SectionRowContainer from '../components/layout/SectionRowContainer.vue';
import SiteBuiltWithInformation from '../components/SiteBuiltWithInformation.vue';

export default {
  name: 'CookiePrivacyPage',
  components: {
    SectionRowContainer,
    SiteBuiltWithInformation,
    VueFragment
  }
};
</script>

<style lang="scss" scoped>
</style>
